import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import axios from '../../util/Api';

const { Option } = Select;
const EducationForm = () => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [educations, setEducations] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = `/master/educations`;
    axios.get(url).then(resp => {
      setEducations(resp.data);
      setLoading(false);
    }).catch(err => {});
  }, []);
  return (
    <>
      <Select
        defaultValue={formik.values.education} onChange={value => formik.setFieldValue("education", value)}
        placeholder="Pilih pendidikan terakhir"
        loading={loading}
      >
        {educations.map((item, key) => {
          return <Option value={item.id} key={`education-${key}`}>{item.name}</Option>
        })}
      </Select>
      <ErrorMessage component="div" name="education" className="gx-mt-2 gx-text-red" />
    </>
  );
}

export default EducationForm;